export default __webpack_public_path__ + "static/media/Subaze.68dba2ec.svg";